import React, { useContext, useEffect, useState } from 'react';
import { gql, useQuery } from '@apollo/client';
import { Helmet } from 'react-helmet';
import { useLocation, useParams } from 'react-router-dom';

import FavoriteIcon from '../components/FavoriteIconUpdate';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link } from 'react-router-dom';
import MasterLayout from '../components/Layout';
import StationItem from '../components/StationItemUpdate';
import classNames from 'classnames';
import moment from 'moment';
import strings from '../utility/strings.js';
import {useAppState} from '../../index.js';

const GET_ITEM_BY_ID = gql`query ($id: Guid!) {
  itemByItemId (itemId: $id) {
    itemId
    name
    ingredients
    isNutritionReady
    nutritionFacts {
      dailyValueLabel
      label
      name
      value
    }
    traits {
      svgIcon
      svgIconWithoutBackground
      name
      type
    }
    appearances {
      date
      locationName
      stationName
      mealName
    }
    components {
      itemId
      name
      isFlaggedForCurrentUser
      isHiddenForCurrentUser
      isNutritionReady
      traits {
        svgIcon
        svgIconWithoutBackground
        name
        type
      }
    }
  }
}`;

const GET_ITEM_BY_MENU_ID = gql`query ($id: Guid!) {
  itemAppearance (itemMenuId: $id) {
    item {
      itemId
      name
      ingredients
      isNutritionReady
      nutritionFacts {
        dailyValueLabel
        label
        name
        value
      }
      traits {
        svgIcon
        svgIconWithoutBackground
        name
        type
      }
      appearances {
        date
        locationName
        stationName
        mealName
      }
    }
    displayName
    specialName
    id
    hasComponents
    components {
      item {
        itemId
        name
        isFlaggedForCurrentUser
        isHiddenForCurrentUser
        isNutritionReady
        traits {
          svgIcon
          svgIconWithoutBackground
          name
          type
        }
      }
      specialName
      itemMenuId
      id      
    }
  }
}`;


const ItemContent = (props) => {
  const { item, AppContext, upcomingHours, displayLastLocation, lastLocation, currentUser } = props;
  const { styleprops } = useContext(AppContext);

  let nutritionInfo, traits, ingredients = null;
  let calories = null;
  let toSkip = ["Serving Size", "Calories", "Calories from fat"];
  let subRows = ["Saturated fat", "Dietary Fiber", "Sugar", "Added Sugar"];
  let traitList = [];

  if (item.nutritionFacts && item.nutritionFacts.length > 0) {
    nutritionInfo = item.nutritionFacts.map((nutrition) => {
      if (toSkip.indexOf(nutrition.name) >= 0) { return null };
      let nutritionValue = nutrition.label;
      let rowClass = classNames(["nutrition-table-row", {
        "subRow": (subRows.indexOf(nutrition.name) !== -1),
        "splitter": nutrition.ordinal === 11 // NOTE: this is questionable... not sure if it holds up
      }]);

      let labelValue = nutritionValue !== null ? <span className="table-row-labelValue">{nutritionValue.toString().replace("less than", "< ").replace(" g", "g")}</span> : null;

      let dailyValue = nutrition.dailyValueLabel !== null && nutrition.dailyValueLabel !== '' ? <span className="table-row-dailyValue">{nutrition.dailyValueLabel.replace('%', '')}</span> : null;

      return (
        <div className={rowClass} key={"item" + nutrition.name}>
          <span className="table-row-label">{nutrition.name}</span>
          {labelValue}
          {dailyValue}
        </div>
      )
    });
  }
  //setting up variables
  if (item.traits) {

    traitList = item.traits.map((allergen) => {
      let iconUrl = allergen.svgIcon;
      return (
        <div className="allergen" key={allergen.name + "_" + Math.floor(Math.random() * 99)}>
          <i className="allergen-icon" style={{ backgroundImage: 'url(' + iconUrl + ')' }} />
          <span className="allergen-name">{allergen.name}</span>
        </div>
      );
    });

    // If there are traits then display the traitlist, if not display the no traits message.
    traits = <div className="item-widget allergens">
      <div className="item-widget-title"><span>Dietary Tags</span></div>
      {traitList.length > 0 ? traitList : <div className="allergens-no-tags">No dietary tags found for this item.</div>}
    </div>
  }

  if (item.ingredients) {
    let array = item.ingredients.split("Contains 2% Or Less Of The Following:");

    let list = array.map((ingredient, i) => {
      let label = i > 0 ? <div className="ingredient-label">Contains 2% Or Less Of The Following:</div> : null;
      let className = i > 0 ? "small" : "";
      return <div key={"ing" + i} className={className}> {label}{ingredient.replace(/[(]/g, ' (')}</div>
    });

    ingredients = <div className="item-widget--large nutrition-ingredients">
      <div className="item-widget-title"><span>Ingredients</span></div>
      <div className="nutrition-ingredient-list">{list}</div>
    </div>
  }

  if (item.components && item.components.length > 0) {
    // Render a Collection Here
    return (
      <main className={"mdl-layout__content"} style={{ ...styleprops, paddingTop: 68 }}>
        {displayLastLocation && lastLocation !== null ? <div className="md-layout__breadcrumbs"><Link to={lastLocation.lastPath} className="md-layout__breadcrumbs--link"><KeyboardArrowLeftIcon />{lastLocation.lastString}</Link></div>: null}
        <div className="item-widget-name" id="main">
          {currentUser !== "Guest" ?
            <FavoriteIcon style={{ color: "#BF8F18" }} currentUser={currentUser} itemId={item.itemId} key="favoriteLink" id="item-favorite-icon" showToolTip={true} />
            : ""
          }<h1 className="item-widget-name__name">{item.name}</h1>
        </div>

        <div className="item-widget station">
          <div className="item-widget__item-info station-container">
            <div className="item-widget-title"><span>Components</span></div>

            <div className="station-items">
              {
                item.components.length > 0 ?
                  item.components.map((x) => {
                    return <StationItem favorites={[]} 
                    currentUser={currentUser} 
                    specialName={null} 
                    key={x.itemId}
                    collectionId={item.itemId}
                    collectionName={item.name}
                    linkToMenuId={false}
                    {...x}
                    />
                  })
                  : null
              }
            </div>

          </div>
          {/* <CollectionMessage /> */}
          <div className="item-widget__upcoming-meals">
            {upcomingHours}
          </div>
        </div>
        <div key={"disclaimer"} className="menu-disclaimer"><p>{strings.disclaimer}</p></div>
      </main>
    )
  } else {
    // Render an Item Here
    return <main className={"mdl-layout__content"} style={{ ...styleprops, paddingTop: 68 }}>
      {/* breadcrumb navigation */}
      {displayLastLocation && lastLocation !== null ? <div className="md-layout__breadcrumbs"><Link to={lastLocation.lastPath} className="md-layout__breadcrumbs--link"><KeyboardArrowLeftIcon />{lastLocation.lastString}</Link></div>: null}
      <div className="item-widget-name" id="main">
        {currentUser !== "Guest" ? <FavoriteIcon style={{ color: "#BF8F18" }} currentUser={currentUser} itemId={item.itemId} key="favoriteLink" id="item-favorite-icon" showToolTip={true} /> : ""}<h1 className="item-widget-name__name">{item.name}</h1>
      </div>
      <div className="item-widget">
        {item.nutritionFacts ? <NutritionFacts item={item} calories={calories} nutritionInfo={nutritionInfo} /> : <NoNutrition />}
        {
          !item.isNutritionReady ? <div className="item-widget allergens warning">
            <div className="item-widget-title"><span>Dietary Tags</span></div>
            <div className="allergen">
              <i className="allergen-icon warning" />
              <span className="allergen-name">Allergen Information is unavailable for this item.<br /> Please see the supervisor on duty for information.</span>
            </div>
          </div> : <div className="item-widget__item-info">
            <div className="item-widget-allergens"> {traits} </div>
            <div className="item-widget-ingredients"> {ingredients} </div>
          </div>
        }
        <div className="item-widget__upcoming-meals">
          {upcomingHours}
        </div>
      </div>
      <div key={"disclaimer"} className="menu-disclaimer"><p>{strings.disclaimer}</p></div>
    </main>
  }

}

const NutritionFacts = (props) => {
  const { item, nutritionInfo } = props;
  let servingSize = item.nutritionFacts.find((o) => o.name === 'Serving Size');
  let calories = item.nutritionFacts.find((o) => o.name === 'Calories');
  return (
    <div className="item-widget--large nutrition item-widget__nutrition">
      <div className="item-widget-title"><span>Nutrition Facts</span></div>

      <div className="nutrition-feature-servingSize">
        <span className="nutrition-feature-servingSize-label">Serving size</span>
        <span className="nutrition-feature-servingSize-quantity">{servingSize.label.replace('Serving', '')}
          {/* <span className="nutrition-feature-servingSize-unit">{calories !== null ? calories[1] : null}</span> */}
        </span>
      </div>

      <div className="nutrition-feature-calories">
        <span className="nutrition-feature-calories-quantity">
          {calories.label}
        </span>
        <span className="nutrition-feature-calories-label">
          <span className="calories-label-title">amount per {servingSize.label.replace('Serving', '')}</span>
          Calories </span>
      </div>

      <div className="nutrition-table">
        <div className="nutrition-table-row__header">
          <div className="table-row-col text--right tenth">
            % DV <sup className="footnote-indicator" style={{fontSize: '0.75em', verticalAlign: 'super', lineHeight: '1'}}>*</sup>
          </div>
        </div>
        {nutritionInfo}
      </div>

      <div className="nutrition-footnote">
        <div>
          <sup className="footnote-indicator" style={{fontSize: '0.75em', verticalAlign: 'super', lineHeight: '1'}}>*</sup>
          Percent Daily Values are based on a 2,000 calorie diet. Your daily value may be higher or lower depending on your calorie needs.
        </div>
      </div>
    </div>
  )
}
const NoNutrition = () => {
  return (
    <div className="item-widget--large nutrition item-widget__nutrition">
      <div className="item-widget-title"><span>Nutrition information is unavailable for this item.</span></div>
    </div>
  )
}

const Item = (props) => {
  const {locations, currentUser, GET_USER} = useAppState();
  const { AppContext, upcoming, match, goBack } = props;
  const { itemId, itemMenuId } = useParams();
  let { state } = useLocation();
  const [item, setItem] = useState(null);
  const [appearances, setAppearances] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const lastLocation = state; // making it clear what we are passing than just "state"
  const [displayLastLocation, setDisplayLastLocation] = useState(false);
  let upcomingPerPage = 8;
  let isCollection = item && item.components && item.components.length > 0 ? true : false;

  const { loading, data } = useQuery(itemMenuId !== undefined ? GET_ITEM_BY_MENU_ID : GET_ITEM_BY_ID, { // Removed unused 'error' variable
    variables: { id: itemMenuId !== undefined ? itemMenuId : itemId }
  });

  useEffect(() => {
    if (!loading && itemMenuId === undefined) {
      setItem(data.itemByItemId);
      setAppearances(data.itemByItemId.appearances);
    } else if (!loading && itemMenuId !== undefined) {
      setItem(
        {
          ...data.itemAppearance.item,
          components: data.itemAppearance.components.map((x) => {
            return {
              ...x.item,
              itemMenuId: x.itemMenuId,
              specialName: x.specialName
            }
          })
        }
      );
      setAppearances(data.itemAppearance.item.appearances);
    }
  }, [loading, data, itemMenuId]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scroll(0, 0);
    }
  }, []);

  useEffect(() => {
    if (lastLocation !== null) {
      setDisplayLastLocation(true);
    }
  }, [lastLocation]);

  function prevHours() {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
    else if (currentPage === 1) {
      setCurrentPage(Math.ceil(upcoming.length / upcomingPerPage));
    }
  }

  function nextHours() {
    if (currentPage < Math.ceil(upcoming.length / upcomingPerPage)) {
      setCurrentPage(currentPage + 1)
    }
    else if (currentPage === Math.ceil(upcoming.length / upcomingPerPage)) {
      setCurrentPage(1)
    }
  }

  let output;
  if (item && item.itemId === itemId) {
    let upcomingHours = <div className="item-widget-upcoming-hours">
      <div className={`item-widget-title ${isCollection ? 'collection' : ''}`}><span>Upcoming Meals</span></div>
      This item is not currently appearing in any upcoming meals.
    </div>

    if (appearances.length > 0) {
      const indexOfLastHour = currentPage * upcomingPerPage;
      const indexOfFirstHour = indexOfLastHour - upcomingPerPage;
      const currentHours = appearances.slice(indexOfFirstHour, indexOfLastHour);
      let buttons;
      //Check to make sure there are multiple pages, if there are; then display the buttons.
      if (appearances && Math.ceil(appearances.length / upcomingPerPage) !== 1) {
        buttons = <div className="upcoming-hours__buttons">
          <button onClick={prevHours} type="button" className="flat-button">
            <div>
              <KeyboardArrowLeftIcon />
              <span >Previous</span>
            </div>
          </button>
          <button onClick={nextHours} type="button" className="flat-button">
            <div>
              <span >Next</span>
              <KeyboardArrowRightIcon />
            </div>
          </button>
        </div>
      }
      else {
        buttons = null;
      }

      if (appearances && appearances.length > 0) {
        let mappedUpcomingHours = currentHours.map(function (a, i) {
          let location = a.locationName,
            date = moment(a.date, "YYYY-MM-DD"),
            station = a.stationName,
            meal = a.mealName,
            key = [date, i, meal, Math.floor(Math.random())].join("_");
          return (
            <Link key={key}
              to={'/' + location + "/" + date.format("YYYY/M/D") + "/" + encodeURIComponent(meal)}
              className="appearances__appearance">
              <div className="appearances__appearance--details">
                <span className="appearances__appearance--date">{date.format("MMM. D")}</span>
                <span className="appearances__appearance--name">{location} {meal}</span>
                <span className="appearances__appearance--station">{station}</span>
              </div>
            </Link>
          )
        });
        upcomingHours = (
          <div className="item-widget-upcoming-hours">
            <div className={`item-widget-title ${isCollection ? 'collection' : ''}`}><span>Upcoming Meals</span></div>
            <div className="item-widget-upcoming-hours__appearances">
              {mappedUpcomingHours}
              {buttons}
            </div>
          </div>
        )
      }
    }

    let altBackLink = <a href={"/"} onClick={goBack} className={classNames('mobile-only', 'floatIcon')}><KeyboardArrowLeftIcon /></a>

    let layout_size = 2;//upcoming meals and the nutrition facts

    const itemTitle = item.name ? `${item.name} - Menu Item Details` : 'Menu Item Details';
    const itemDescription = item.ingredients ? 
      `View nutrition facts, ingredients, and dietary information for ${item.name}.` :
      `View detailed information about this menu item from Purdue Dining including nutrition facts and dietary traits.`;

    //Render content
    output = (<>
      <Helmet>
        <title>{itemTitle} - Purdue Dining</title>
        <meta name="description" content={itemDescription} />
        <meta name="keywords" content={`${item.name}, nutrition facts, ingredients, dietary information, Purdue dining`} />
        <meta property="og:title" content={itemTitle} />
        <meta property="og:description" content={itemDescription} />
      </Helmet>
      <MasterLayout AppContext={AppContext} locations={locations} currentUser={currentUser} GET_USER={GET_USER} pageName={' '}>
      <ItemContent
        AppContext={AppContext}
        lastLocation={lastLocation}
        displayLastLocation={displayLastLocation}
        altBackLink={altBackLink}
        match={match}
        item={item}
        layout_size={layout_size}
        upcomingHours={upcomingHours}
        locations={locations} 
        currentUser={currentUser} 
        GET_USER={GET_USER}
      />
    </MasterLayout>
    </>)
  }
  else {
    //return loading screen if the state isn't ready yet. This is to reduce old data flash...
    output = <MasterLayout AppContext={AppContext} locations={locations} currentUser={currentUser} GET_USER={GET_USER} pageName="Loading"><main className="mdl-layout__content" style={{ minHeight: "300px" }}>
      <div className={'loading'} style={{ paddingTop: "100px", background: "#ffffff" }}>
        <div className="circle">
          <div className="circle">
            <div className="circle">
              <div className="circle-center">
                <div className="circle-center__inner"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="loading-text" style={{ color: "#444" }}>{"Loading Item"}</div>
      </div>
    </main></MasterLayout>
  }

  return (
    output
  )
}

// export default withLastLocation(Collection);
export default Item;